import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  CircularProgress,
  Snackbar,
  Alert,
  Tooltip,
  TablePagination,
  Chip,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Menu // Add Menu import
} from "@mui/material";
import {
  Edit,
  Delete,
  Visibility,
  Add,
  Search,
  Work,
  Business,
  LocationOn,
  AccessTime,
  Person,
  EventAvailable,
  CheckCircle,
  Cancel,
  Warning,
  Badge,
  Email,
  PersonAdd,
  Send,
  MoreVert // Add MoreVert icon for 3 dots
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const JobView = () => {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState({ open: false, message: "", severity: "success" });
  const [deleteDialog, setDeleteDialog] = useState({ open: false, jobId: null });
  const [viewDialog, setViewDialog] = useState({ open: false, job: null });
  const [emailDialog, setEmailDialog] = useState({ open: false, job: null });
  const [searchQuery, setSearchQuery] = useState("");
  const [userRole, setUserRole] = useState(""); // hr, manager, employee
  const [emailData, setEmailData] = useState({
    recipients: "",
    subject: "",
    message: ""
  });
 
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
 
  // Add state for menu
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);
  useEffect(() => {
    fetchJobs(0, rowsPerPage, searchQuery);
    getUserRole();
  }, []);
  useEffect(() => {
    setPage(0);
  }, [searchQuery]);
  useEffect(() => {
    fetchJobs(page, rowsPerPage, searchQuery);
  }, [page, rowsPerPage, searchQuery]);
  const getUserRole = () => {
    // Get user role from localStorage or API
    const role = localStorage.getItem("role") || "employee"; // Default to employee
    setUserRole(role);
  };
  const fetchJobs = async (currentPage = 0, currentLimit = 5, currentSearch = "") => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
        if (!token) {
          alert("No authentication token found. Please log in.");
          return;
        }
        const payload = JSON.parse(atob(token.split('.')[1]));
        const company_id = payload.company_id;
      let url = `${API_URL}/api/jobpost/list?page=${currentPage}&limit=${currentLimit}`;
      if (currentSearch.trim()) {
        url += `&search=${encodeURIComponent(currentSearch)}`;
      }
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
     
      const processedJobs = response.data.jobs.map(job => {
        const closingDate = new Date(job.jobClosedDate);
        const today = new Date();
        const daysDifference = Math.ceil((closingDate - today) / (1000 * 60 * 60 * 24));
       
        let status;
        if (closingDate < today) {
          status = "Closed";
        } else if (daysDifference <= 7) {
          status = "Closing Soon";
        } else {
          status = "Open";
        }
       
        return { ...job, status };
      });
     
      setJobs(processedJobs);
      setTotalCount(response.data.pagination?.total || 0);
      setLoading(false);
    } catch (error) {
      //console.error("Error fetching jobs:", error);
      setAlert({
        open: true,
        message: "Failed to fetch jobs. Please try again.",
        severity: "error",
      });
      setLoading(false);
    }
  };
  // Menu handlers
  const handleMenuOpen = (event, job) => {
    setMenuAnchor(event.currentTarget);
    setSelectedJob(job);
  };
  const handleMenuClose = () => {
    setMenuAnchor(null);
    setSelectedJob(null);
  };
  const handlePostToLinkedIn = () => {
    if (selectedJob) {
      // Logic for posting to LinkedIn
      const linkedinUrl = `https://www.linkedin.com/jobs/post/?title=${encodeURIComponent(selectedJob.jobTitle)}&description=${encodeURIComponent(selectedJob.description)}`;
      window.open(linkedinUrl, '_blank');
     
      setAlert({
        open: true,
        message: "Redirecting to LinkedIn job posting...",
        severity: "info",
      });
    }
    handleMenuClose();
  };
  const handlePostToNaukri = () => {
    if (selectedJob) {
      // Logic for posting to Naukri
      const naukriUrl = `https://www.naukri.com/tia/jobs/post`;
      window.open(naukriUrl, '_blank');
     
      setAlert({
        open: true,
        message: "Redirecting to Naukri job posting...",
        severity: "info",
      });
    }
    handleMenuClose();
  };
  const handleCreateJob = () => {
    navigate("/job-posting");
  };
  const handleEditJob = (job) => {
    navigate(`/job-posting/${job.id}`, { state: { job } });
  };
  const handleViewJob = (job) => {
    setViewDialog({ open: true, job });
  };
  const handleDeleteConfirm = (id) => {
    setDeleteDialog({ open: true, jobId: id });
  };
  const handleDeleteJob = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
        if (!token) {
          alert("No authentication token found. Please log in.");
          return;
        }
        const payload = JSON.parse(atob(token.split('.')[1]));
        const company_id = payload.company_id;
      await axios.delete(`${API_URL}/api/jobpost/delete/${deleteDialog.jobId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
  
              "Content-Type": "application/json"
          
        },
      });
     
      setAlert({
        open: true,
        message: "Job deleted successfully",
        severity: "success",
      });
     
      setDeleteDialog({ open: false, jobId: null });
      fetchJobs(page, rowsPerPage, searchQuery);
    } catch (error) {
      //console.error("Error deleting job:", error);
      setAlert({
        open: true,
        message: "Failed to delete job. Please try again.",
        severity: "error",
      });
      setLoading(false);
      setDeleteDialog({ open: false, jobId: null });
    }
  };
  const handleApplyJob = (job) => {
    navigate("/refer", {
      state: {
        job,
        action: "apply",
        jobTitle: job.jobTitle,
        department: job.department,
        location: job.location,
        description:job.description
      }
    });
  };
  const handleReferJob = (job) => {
    navigate("/refer", {
      state: {
        job,
        action: "refer",
        jobTitle: job.jobTitle,
        department: job.department,
        location: job.location,
        description:job.description
      }
    });
  };
  const handleSendEmail = (job) => {
    setEmailData({
      recipients: "",
      subject: `Job Opportunity: ${job.jobTitle} at ${job.department}`,
      message: `Hi,\n\nI wanted to share this exciting job opportunity with you:\n\nPosition: ${job.jobTitle}\nDepartment: ${job.department}\nLocation: ${job.location}\nEmployment Type: ${job.employmentType}\nClosing Date: ${formatDate(job.jobClosedDate)}\n\nDescription:\n${job.description}\n\n`
    });
    setEmailDialog({ open: true, job });
  };
  const handleSendEmailSubmit = async () => {
    try {
      const token = localStorage.getItem('token');
        if (!token) {
          alert("No authentication token found. Please log in.");
          return;
        }
        const payload = JSON.parse(atob(token.split('.')[1]));
        const company_id = payload.company_id;
      await axios.post(`${API_URL}/api/jobpost/send-email`, {
        jobId: emailDialog.job.id, // Send job ID instead of job object
        recipients: emailData.recipients.split(',').map(email => email.trim()),
        subject: emailData.subject,
        message: emailData.message,
      },{
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      });
     
      setAlert({
        open: true,
        message: "Email sent successfully!",
        severity: "success",
      });
     
      setEmailDialog({ open: false, job: null });
      setEmailData({ recipients: "", subject: "", message: "" });
    } catch (error) {
      //console.error("Error sending email:", error);
      setAlert({
        open: true,
        message: error.response?.data?.message || "Failed to send email. Please try again.",
        severity: "error",
      });
    }
  };
  const handleCloseAlert = () => {
    setAlert({ ...alert, open: false });
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const renderStatusChip = (status) => {
    let icon, color, bgcolor;
   
    switch (status) {
      case "Open":
        icon = <CheckCircle fontSize="small" />;
        color = "success";
        bgcolor = "#28a745";
        break;
      case "Closed":
        icon = <Cancel fontSize="small" />;
        color = "error";
        bgcolor = "#dc3545";
        break;
      case "Closing Soon":
        icon = <Warning fontSize="small" />;
        color = "warning";
        bgcolor = "#ffc107";
        break;
      default:
        icon = <CheckCircle fontSize="small" />;
        color = "primary";
        bgcolor = "#e8f5e9";
    }
   
    return (
      <Chip
        icon={icon}
        label={status}
        color={color}
        size="small"
        style={{ backgroundColor: bgcolor, fontWeight: "500" }}
      />
    );
  };
  if (loading && jobs.length === 0) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: "50px" }}>
        <CircularProgress />
      </div>
    );
  }
  return (
    <div style={{}}>
      <Snackbar
        open={alert.open}
        autoHideDuration={6000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseAlert} severity={alert.severity}>
          {alert.message}
        </Alert>
      </Snackbar>
     
      <Card sx={{ maxWidth: "1600px", mt: 3, borderRadius: 2, // Rounded corners
    border: '2px solid',
    borderColor: 'grey.300', // Subtle professional border
    boxShadow: 4, mx: 3 }}>
        <CardHeader
          title={
            <Box sx={{ display: "flex",  }}>
              <Typography variant="h4" fontWeight="bold">
                Job View
              </Typography>
            </Box>
          }
          titleTypographyProps={{ variant: "h4" }}
        />
        <CardContent>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <TextField
              label="Search"
              variant="outlined"
              size="small"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                endAdornment: <Search color="action" />,
              }}
              sx={{ width: 300 }}
            />
           
            {/* Only show Create Job button for HR */}
            {userRole === "hr" && (
              <Button
                variant="contained"
                color="primary"
                startIcon={<Add />}
                onClick={handleCreateJob}
              >
                Create Job
              </Button>
            )}
          </Box>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                  <TableCell style={{ fontWeight: "bold", cursor: "pointer" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Badge style={{ marginRight: "6px" }} fontSize="small" />
                      Job ID
                    </div>
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Work style={{ marginRight: "6px" }} fontSize="small" />
                      Title
                    </div>
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Business style={{ marginRight: "6px" }} fontSize="small" />
                      Department
                    </div>
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <LocationOn style={{ marginRight: "6px" }} fontSize="small" />
                      Location
                    </div>
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <AccessTime style={{ marginRight: "6px" }} fontSize="small" />
                      Employment Type
                    </div>
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Person style={{ marginRight: "6px" }} fontSize="small" />
                      Positions
                    </div>
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Person style={{ marginRight: "6px" }} fontSize="small" />
                      Hiring Manager
                    </div>
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <EventAvailable style={{ marginRight: "6px" }} fontSize="small" />
                      Closing Date
                    </div>
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <CheckCircle style={{ marginRight: "6px" }} fontSize="small" />
                      Status
                    </div>
                  </TableCell>
                  {/* Show Actions column for HR */}
                  {userRole === "hr" && (
                    <TableCell style={{ fontWeight: "bold" }}>Actions</TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {jobs.length > 0 ? (
                  jobs.map((job) => (
                    <TableRow key={job.id}>
                      <TableCell
                        style={{
                          color: "#1976d2",
                          cursor: "pointer",
                          textDecoration: "underline"
                        }}
                        onClick={() => handleViewJob(job)}
                      >
                        {job.jobId}
                      </TableCell>
                      <TableCell>{job.jobTitle}</TableCell>
                      <TableCell>{job.department}</TableCell>
                      <TableCell>{job.location}</TableCell>
                      <TableCell>{job.employmentType}</TableCell>
                      <TableCell>{job.noOfPositions}</TableCell>
                      <TableCell>{job.hiringManagerName}</TableCell>
                      <TableCell>{formatDate(job.jobClosedDate)}</TableCell>
                      <TableCell>{renderStatusChip(job.status)}</TableCell>
                      {/* Show action buttons for HR */}
                      {userRole === "hr" && (
                        <TableCell>
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Tooltip title="Edit">
                              <IconButton
                                color="primary"
                                onClick={() => handleEditJob(job)}
                                size="small"
                              >
                                <Edit />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Delete">
                              <IconButton
                                color="error"
                                onClick={() => handleDeleteConfirm(job.id)}
                                size="small"
                              >
                                <Delete />
                              </IconButton>
                            </Tooltip>
                            {/* 3-dots Menu */}
                            {/* <Tooltip title="More options">
                              <IconButton
                                onClick={(e) => handleMenuOpen(e, job)}
                                size="small"
                              >
                                <MoreVert />
                              </IconButton>
                            </Tooltip> */}
                          </Box>
                        </TableCell>
                      )}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={userRole === "hr" ? 10 : 9} align="center">
                      {loading ? "Loading..." : "No jobs found"}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        </CardContent>
      </Card>
      {/* 3-dots Menu */}
      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={handlePostToLinkedIn}>
          Post via LinkedIn
        </MenuItem>
        <MenuItem onClick={handlePostToNaukri}>
          Post via Naukri
        </MenuItem>
      </Menu>
      {/* Enhanced View Dialog */}
      <Dialog
        open={viewDialog.open}
        onClose={() => setViewDialog({ open: false, job: null })}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          style: {
            minHeight: '70vh',
            maxHeight: '90vh',
          }
        }}
      >
        {viewDialog.job && (
          <>
            <DialogTitle>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Work style={{ marginRight: "10px" }} />
                Job Details: {viewDialog.job.jobTitle}
              </div>
            </DialogTitle>
            <DialogContent dividers style={{ padding: '24px' }}>
              <TableContainer>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell style={{ fontWeight: "bold", width: "30%" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Badge style={{ marginRight: "8px" }} />
                          Job ID
                        </div>
                      </TableCell>
                      <TableCell>{viewDialog.job.jobId}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: "bold" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Work style={{ marginRight: "8px" }} />
                          Title
                        </div>
                      </TableCell>
                      <TableCell>{viewDialog.job.jobTitle}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: "bold" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Business style={{ marginRight: "8px" }} />
                          Department
                        </div>
                      </TableCell>
                      <TableCell>{viewDialog.job.department}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: "bold" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <LocationOn style={{ marginRight: "8px" }} />
                          Location
                        </div>
                      </TableCell>
                      <TableCell>{viewDialog.job.location}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: "bold" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <AccessTime style={{ marginRight: "8px" }} />
                          Employment Type
                        </div>
                      </TableCell>
                      <TableCell>{viewDialog.job.employmentType}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: "bold" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Person style={{ marginRight: "8px" }} />
                          Number of Positions
                        </div>
                      </TableCell>
                      <TableCell>{viewDialog.job.noOfPositions}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: "bold" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <CheckCircle style={{ marginRight: "8px" }} />
                          Status
                        </div>
                      </TableCell>
                      <TableCell>{viewDialog.job.status && renderStatusChip(viewDialog.job.status)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: "bold" }}>Experience Required</TableCell>
                      <TableCell>{viewDialog.job.experience}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: "bold" }}>Salary Range</TableCell>
                      <TableCell>{viewDialog.job.budget}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: "bold" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <EventAvailable style={{ marginRight: "8px" }} />
                          Job Closing Date
                        </div>
                      </TableCell>
                      <TableCell>{formatDate(viewDialog.job.jobClosedDate)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: "bold" }}>Hiring Manager</TableCell>
                      <TableCell>{viewDialog.job.hiringManagerName}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: "bold" }}>Description</TableCell>
                      <TableCell style={{ whiteSpace: "pre-wrap" }}>{viewDialog.job.description}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </DialogContent>
            <DialogActions style={{ padding: '16px 24px', gap: '8px' }}>
  <Tooltip title={viewDialog.job.status === "Closed" ? "This job is closed and cannot be applied to" : "Apply for this job"}>
    <span>
      <Button
        onClick={() => handleApplyJob(viewDialog.job)}
        color="success"
        variant="contained"
        startIcon={<Person />}
        disabled={viewDialog.job.status === "Closed"}
      >
        Apply Job
      </Button>
    </span>
  </Tooltip>
 
  <Tooltip title={viewDialog.job.status === "Closed" ? "This job is closed and cannot be referred" : "Refer someone for this job"}>
    <span>
      <Button
        onClick={() => handleReferJob(viewDialog.job)}
        color="info"
        variant="contained"
        startIcon={<PersonAdd />}
        disabled={viewDialog.job.status === "Closed"}
      >
        Refer Job
      </Button>
    </span>
  </Tooltip>
 
  <Tooltip title={viewDialog.job.status === "Closed" ? "This job is closed and cannot be shared" : "Share this job via email"}>
    <span>
      <Button
        onClick={() => {
          setViewDialog({ open: false, job: null });
          handleSendEmail(viewDialog.job);
        }}
        color="warning"
        variant="contained"
        startIcon={<Email />}
        disabled={viewDialog.job.status === "Closed"}
      >
        Send Email
      </Button>
    </span>
  </Tooltip>
 
  <Button
    onClick={() => setViewDialog({ open: false, job: null })}
    color="primary"
    variant="outlined"
  >
    Cancel
  </Button>
</DialogActions>
          </>
        )}
      </Dialog>
      {/* Email Dialog */}
      <Dialog
        open={emailDialog.open}
        onClose={() => setEmailDialog({ open: false, job: null })}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Email style={{ marginRight: "10px" }} />
            Send Job via Email
          </div>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
            <TextField
              label="Recipients (comma separated emails)"
              fullWidth
              value={emailData.recipients}
              onChange={(e) => setEmailData({ ...emailData, recipients: e.target.value })}
              placeholder="example1@email.com, example2@email.com"
              required
            />
            <TextField
              label="Subject"
              fullWidth
              value={emailData.subject}
              onChange={(e) => setEmailData({ ...emailData, subject: e.target.value })}
              required
            />
            <TextField
              label="Message"
              fullWidth
              multiline
              rows={8}
              value={emailData.message}
              onChange={(e) => setEmailData({ ...emailData, message: e.target.value })}
              required
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setEmailDialog({ open: false, job: null })}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSendEmailSubmit}
            color="primary"
            variant="contained"
            startIcon={<Send />}
            disabled={!emailData.recipients || !emailData.subject || !emailData.message}
          >
            Send Email
          </Button>
        </DialogActions>
      </Dialog>
      {/* Delete Dialog */}
      <Dialog
        open={deleteDialog.open}
        onClose={() => setDeleteDialog({ open: false, jobId: null })}
      >
        <DialogTitle>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Delete style={{ marginRight: "10px", color: "#f44336" }} />
            Confirm Delete
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            This action will permanently remove the job posting. Are you sure you want to proceed?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDeleteDialog({ open: false, jobId: null })}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteJob}
            color="error"
            variant="contained"
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default JobView;